import { render } from "./MainPresentazione.vue?vue&type=template&id=bf627c30&scoped=true"
import script from "./MainPresentazione.vue?vue&type=script&lang=js"
export * from "./MainPresentazione.vue?vue&type=script&lang=js"

import "./MainPresentazione.vue?vue&type=style&index=0&id=bf627c30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf627c30"]])

export default __exports__